import type { FC, ReactNode } from "react";
import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "../hooks/useAuth";
// import Login from "../pages/authentication/Login";
import CryptoJS from "crypto-js";
import Login from "src/UIS_containers/pages/Authenticate/Login";
interface AuthGuardProps {
    children: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = (props) => {
    const { children } = props;
    const auth = useAuth();
    const location = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);
    let tmp = JSON.parse(localStorage.getItem("authorizationData"));
    if (tmp) {
        let now = new Date();
        let Exptime = new Date(tmp.Expire);
        if (now > Exptime) {
            localStorage.removeItem("authorizationData");
            return <Login />;
        }
    } else {
        return <Login />;
    }
    if (!auth.isAuthenticated) {
        if (location.pathname !== requestedLocation) {
            setRequestedLocation(location.pathname);
        }
        return <Login />;
    }
    // This is done so that in case the route changes by any chance through other
    // means between the moment of request and the render we navigate to the initially
    // requested route.
    if (requestedLocation && location.pathname !== requestedLocation) {
        setRequestedLocation(null);

        return <Navigate to={requestedLocation} />;
    }
    if (auth.isAuthenticated) {
        // console.log(auth.authmenu);
        let authorizationData = JSON.parse(
            localStorage.getItem("authorizationData")
        );
        if (authorizationData) {
            if (!IsAuthenRouting(auth.authmenu)) return <Navigate to="/401" />;
        }
    }
    return <>{children}</>;
};

AuthGuard.propTypes = {
    children: PropTypes.node,
};

export default AuthGuard;

function IsAuthenRouting(authmenu: any) {
    // return true
    let Auth = false;
    let AuthMenu = JSON.parse(decrypt(authmenu));
    let authorizationData = JSON.parse(
        localStorage.getItem("authorizationData")
    );
    let currentlocation = useLocation().pathname.toString();
    let AuthRoutes = [];
    if (AuthMenu.length > 0 && authorizationData) {
        AuthMenu.map((el) => {
            el.items.map((item) => {
                AuthRoutes.push(item.path);
            });
        });
    }
    if (
        authorizationData.Role == "SV" ||
        authorizationData.Role == "CSV" ||
        authorizationData.Role == "TSV"
    ) {
        if (currentlocation == "/student") {
            Auth = true;
            return Auth;
        }
    } else if (authorizationData.Role == "GV") {
        if (currentlocation == "/professor") {
            Auth = true;
            return Auth;
        }
    } else {
        if (currentlocation == "/staff") {
            Auth = true;
            return Auth;
        }
    }
    if (AuthRoutes.length > 0) {
        AuthRoutes.map((el) => {
            if (currentlocation.startsWith(el)) {
                Auth = true;
                return Auth;
            }
        });
    }

    return Auth;
}

function decrypt(data: any) {
    var key = "2e35f242a46d67eeb74aabc37d5e5d05";
    var decrypted = CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8); // Message
    return decrypted;
}
